import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import disproportionatePublicReadAction from './disproportionatePublicRead.action.json' assert { type: 'json' }

const disproportionatePublicReadDefinition = defineReadAutoAction(
  disproportionatePublicReadAction,
  'disproportionateAttentionPublic',
)

export default disproportionatePublicReadDefinition
